import { createSelector } from 'reselect';
import fallbackProfilePhoto from 'images/random-profile-1.png';
import groupAvatarPhoto from 'images/Group-Avatar.png';

export const TOKEN_TYPE_USER = 'user';
export const TOKEN_TYPE_GROUP = 'group';

const groupsArraySelector = (state) => Object.values(state.groups.groupsById);
const usersArraySelector = (state) => Object.values(state.users.usersById);

const sortAlphabetically = (unsortedArray) => {
  const sortedArray = unsortedArray.sort((a, b) => {
    return a.text.localeCompare(b.text);
  });

  return sortedArray;
};

const convertUsersToMentionTokens = (users) =>
  users.map((user) => ({
    value: user.id,
    text:
      user.full_name ||
      user.email_address ||
      user.phone_number ||
      'InvitedUser',
    imageURL: user.profile_url_mobile || fallbackProfilePhoto,
    type: TOKEN_TYPE_USER,
  }));

const getSortedUserTokens = (users) => {
  const activeUsers = users.filter((user) => user.active);
  const userTokenDefinitions = convertUsersToMentionTokens(activeUsers);

  return sortAlphabetically(userTokenDefinitions);
};

const convertGroupsToMentionTokens = (groups) =>
  groups.map((group) => ({
    value: group.id,
    text: `${group.name} (Group)`,
    imageURL: groupAvatarPhoto,
    type: TOKEN_TYPE_GROUP,
    users: getSortedUserTokens(group.users),
  }));

const getSortedGroupTokens = (groups) => {
  const activeGroups = groups.filter(
    (group) => group.active && group.users.length > 0,
  );
  const groupTokenDefinitions = convertGroupsToMentionTokens(activeGroups);

  return sortAlphabetically(groupTokenDefinitions);
};

const mentionGroupTokensSelector = createSelector(
  [groupsArraySelector],
  getSortedGroupTokens,
);

const mentionTokensSelector = createSelector(
  [usersArraySelector],
  getSortedUserTokens,
);

export {
  sortAlphabetically,
  convertUsersToMentionTokens,
  convertGroupsToMentionTokens,
  getSortedUserTokens,
  getSortedGroupTokens,
  mentionTokensSelector,
  mentionGroupTokensSelector,
};
